/**
 * Stands in for a real code when flag evaluation or serialization fails. It
 * carries no variables, so the page renders control instead of 404ing.
 */
export const FALLBACK_CODE = "fallback";

/**
 * The code of a page no flag is decided for. It carries no variables, so
 * `useFlag` keeps reading the visitor's flag cookies there (e.g. in the Header).
 */
export const NO_FLAGS_CODE = "none";

/** Splits the keys, the flags code and the signature; none of them can contain it. */
export const CODE_SEPARATOR = "~";

/** The leading `[code]` segment: a prebuilt code, or a signed one, which always contains the separator. */
const LEADING_CODE_SEGMENT = new RegExp(`^/(?:${NO_FLAGS_CODE}|${FALLBACK_CODE}|[^/]*${CODE_SEPARATOR}[^/]*)(?=/)`);

/** The visitor-facing path of a page rendered under `[code]`; a path with no code segment is returned as is. Client-safe, unlike `~/lib/flags`. */
export const stripCodeSegment = (pathname: string): string => pathname.replace(LEADING_CODE_SEGMENT, "");
